import { FC, useCallback, useMemo } from 'react'

import { parseDocumentMeta } from '../../../../../../helpers/parseDocumentMeta'
import { IAplDocument } from '../../../../../../models/aplDocument'

import styles from './ListItem.module.scss'

export interface IListItemProps {
  document: IAplDocument

  onClick: (document: IAplDocument) => void
}

export const ListItem: FC<IListItemProps> = ({ document, onClick }) => {
  const handleDownloadItem = useCallback(() => {
    onClick(document)
  }, [onClick, document])

  const meta = useMemo(() => {
    return parseDocumentMeta(document.Meta)
  }, [document.Meta])

  return (
    <div className={styles.root}>
      <span className={styles.language}>{meta?.languageCode}:</span>
      <a className={styles.link} rel="noreferrer" onClick={handleDownloadItem}>
        {document.FileName}
      </a>
    </div>
  )
}
